export default __webpack_public_path__ + "static/media/coworking_space.c43d7485.svg";